import LoadingAnimation from "@/components/ui/loading-animation";

export default function LoadingAnimationWrapper() {
  return (
    <div className="flex h-full flex-1 flex-col items-center justify-center">
      <LoadingAnimation className="h-[120px] w-[120px] sm:h-[180px] sm:w-[180px]" />
    </div>
  );
}
